import { createApp } from 'vue';
import App from '@/App.vue';
import { initLocalization } from '@/i18n';
import { defineCustomElements } from '@telekom/scale-components/loader';
import { useConfig } from './composables/use-config/useConfig';
import { pluginsWrapper } from '@/plugins';
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
import '@/assets/main.scss';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/de';
dayjs.extend(localizedFormat);

defineCustomElements()
  .then(() => {
    const { loadConfig } = useConfig();
    return loadConfig();
  })
  .then(() => {
    return initLocalization();
  })
  .then(() => {
    const app = createApp(App);
    pluginsWrapper(true).install(app).mount('#app');
  });
